<template>
<!-- 储值卡合同管理 -->
    <div class="cards-contract">
        <el-table
            border
            ref="tableData"
            :data='tableData'
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="contractNum" :label="$t('Contract.number')">
                <template slot-scope="{$index, row}">
                    <!-- <a @click="handleShow(row)">{{ row.contractNum }}</a> -->
                    {{ row.contractNum }}
                </template>
            </el-table-column>
            <el-table-column prop="cardNum" :label="$t('Contract.card_hao')"></el-table-column>
            <el-table-column prop="clientName" :label="$t('Member.name2')">
                <template slot-scope="{row}">
                    <span
                        @click="handleUser(row.clientId)"
                        class="task-workers">
                        {{ row.clientName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')" width="110px"></el-table-column>
            <el-table-column prop="cardName" :label="$t('Other.Upload.CardName')" width="120px"></el-table-column>
            <el-table-column prop="cardCredit" label="储值金额"></el-table-column>
            <el-table-column prop="cardBalance" :label="$t('Sell.Charge.current_balance')"></el-table-column>
            <el-table-column prop="type" :label="$t('Contract.type')"></el-table-column>
            <el-table-column :label="$t('Contract.Desc.old_number')">
                <template slot-scope="{row}">
                    <span
                        @click="goDetails(row.originalContractNum)"
                        class="task-workers">
                        {{ row.originalContractNum }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('Contract.status')">
                <template slot-scope="{row}">
                    <span :class="row.status==='有效' ? 'task-status' : 'del-status'">
                        {{ row.status }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="payableAmt" :label="$t('Charge.amount_receivable')"></el-table-column>
            <el-table-column prop="paidAmt" :label="$t('Sell.Charge.paid_amount')"></el-table-column>
            <el-table-column prop="oweAmt" :label="$t('Sell.OutstandingAmount')"></el-table-column>
            <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" width="100px"></el-table-column>
            <el-table-column prop="validity" :label="$t('Contract.validity_period')" width="100px"></el-table-column>
            <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')">
                <template slot-scope="{row}">
                    {{ row.contractSalesStaffNickname }}
                    <template v-if="row.contractSalesStaffNickname!==row.clientMshpSalesNickname">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" >
                                <div>{{ $t('Sell.Unlike_followup_sales') }}</div>
                                <div>{{ $t('Other.Upload.followup_sales') }}：{{row.clientMshpSalesNickname}}</div>
                            </div>
                            <span class="iconfont icon-fitness-point diff-icon"></span>
                        </el-tooltip>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
        <pay-form
            ref="pay"
            :contract="'storeValue'"
            v-model="input"
            @fetchData="fetchData" />
        <!-- 修改合同开始时间 -->
        <modify-batch-time
            :total="pagination.total"
            :activeName="activeName"
            :filter="form"
            :contracts="contracts"
            :tableData="tableData"
            @fetchData="fetchData"
            :date="date"
            ref="batch" />
    </div>
</template>
<script>
import { Dialog } from 'element-ui';
import handleUser from '@/mixins/handleUser.js';
import PayForm from '@/components/Dialog/Client/PayForm';
import ModifyBatchTime from '@/components/Dialog/Sell/ModifyBatchTime.vue';

export default {
    props: ['activeName', 'stores', 'form', 'date', 'contractNum'],
    name: 'cardsContract',
    components: {
        ElDialog: Dialog,
        PayForm,
        ModifyBatchTime,
    },
    mixins: [handleUser],
    data() {
        return {
            loading: false,
            input: '',
            tableData: [],
            contracts: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeName(val) {
            if (val === 'cardsCon') this.fetchData();
        },
        input(val) {
            if (val === 'update') this.flush();
        },
        contractNum(val) {
            this.fetchData(1);
        },
    },
    created() {
        if (this.activeName === 'cardsCon') this.fetchData();
    },
    methods: {
        handleShow(row) {
            this.$router.push({
                name: 'Sell.Show',
                params: {
                    id: row.contractNum,
                    url: 'contract/cz-card',
                },
            });
        },
        flush(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('contract/cz-card/pages', {
                params: {
                    ...this.pagination,
                    statusCode: 1,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            if (this.contractNum) this.form.contractNum = this.contractNum
            if (this.date) {
                this.form.createdAtStart = this.date[0];
                this.form.createdAtEnd = this.date[1];
            }
            API.get('contract/cz-card/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                },
            })
            .then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.tableData.toggleRowSelection(row);
                });
            } else {
                this.$refs.tableData.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.contracts = val;
            this.$emit('headListen', this.contracts);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        validSelect() {
            if (this.contracts.length > 1) $ele.$message.warning(this.$t('Message.once_data'));
            else if (this.contracts.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
        pay() {
            if (this.validSelect()) this.$refs.pay.open(this.contracts[0].contractNum);
        },
        openBatch() {
            this.$refs.batch.open(this.contracts);
        },
        goDetails(val) {
            let form = this.form;
            form.contractNum = val;
            this.$emit('update:form', form);
            this.fetchData();
        },
    },
};
</script>
<style lang="scss">
.cards-contract {
    .task-workers {
        color: #409EFF;
        cursor: pointer;
    }
    .task-status{
        color: #2a9546;
    }
    .del-status {
        color:#ce6969;
    }
    .diff-icon{
        background-color: orange !important;
        border-radius:25px;
        color:white;
    }
}
</style>
